import axios from 'axios';
import { API_URL } from '../../../config/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
};

export const fetchMyNotes = async () => {
  const response = await axios.get(`${API_URL}/notes`, { headers: getHeaders() });
  return Array.isArray(response.data) ? response.data : [];
};

export const fetchNote = async (noteId) => {
  const response = await axios.get(`${API_URL}/notes/${noteId}`, { headers: getHeaders() });
  return response.data;
};

export const createNote = async (payload = {}) => {
  const response = await axios.post(`${API_URL}/notes`, payload, { headers: getHeaders() });
  return response.data;
};

export const updateNote = async (noteId, payload) => {
  const response = await axios.put(`${API_URL}/notes/${noteId}`, payload, { headers: getHeaders() });
  return response.data;
};

export const rewriteNoteWithAi = async ({ mode, title, contentHtml, prompt, language } = {}) => {
  const response = await axios.post(
    `${API_URL}/notes/ai`,
    { mode, title, contentHtml, prompt, language },
    { headers: getHeaders(), timeout: 60000 },
  );
  return response.data;
};

export const deleteNote = async (noteId) => {
  const response = await axios.delete(`${API_URL}/notes/${noteId}`, { headers: getHeaders() });
  return response.data;
};

export const shareNote = async (noteId, { mode, userIds } = {}) => {
  const response = await axios.post(
    `${API_URL}/notes/${noteId}/share`,
    { mode, userIds },
    { headers: getHeaders() },
  );
  return response.data;
};

export const fetchCredentialPinStatus = async () => {
  const response = await axios.get(`${API_URL}/notes/credential-pin`, { headers: getHeaders() });
  return response.data;
};

export const setCredentialPin = async ({ pin, currentPin } = {}) => {
  const response = await axios.put(
    `${API_URL}/notes/credential-pin`,
    { pin, currentPin },
    { headers: getHeaders() },
  );
  return response.data;
};

export const fetchCredentialBucket = async () => {
  const response = await axios.get(`${API_URL}/notes/credentials`, { headers: getHeaders() });
  return Array.isArray(response.data?.items) ? response.data.items : [];
};

export const saveCredentialBucket = async (items) => {
  const response = await axios.put(
    `${API_URL}/notes/credentials`,
    { items },
    { headers: getHeaders() },
  );
  return Array.isArray(response.data?.items) ? response.data.items : [];
};

export const verifyCredentialPin = async (pin) => {
  const response = await axios.post(
    `${API_URL}/notes/credential-pin/verify`,
    { pin },
    { headers: getHeaders() },
  );
  return response.data;
};

export const fetchLinkPreview = async (url) => {
  const response = await axios.get(`${API_URL}/messages/link-preview`, {
    params: { url },
    headers: getHeaders(),
  });
  return response.data;
};

export const fetchNeedToCall = async () => {
  const response = await axios.get(`${API_URL}/need-to-call`, { headers: getHeaders() });
  return Array.isArray(response.data?.items) ? response.data.items : [];
};

export const saveNeedToCall = async (items) => {
  const response = await axios.put(
    `${API_URL}/need-to-call`,
    { items },
    { headers: getHeaders() },
  );
  return Array.isArray(response.data?.items) ? response.data.items : [];
};

export const appendNeedToCallItem = async ({ targetUserId, name, phone, reason } = {}) => {
  const nextName = String(name || '').trim();
  if (!nextName) {
    throw new Error('Whom is required');
  }
  const response = await axios.post(
    `${API_URL}/need-to-call/item`,
    {
      targetUserId: targetUserId || null,
      name: nextName,
      phone: String(phone || '').trim(),
      reason: String(reason || '').trim(),
      done: false,
    },
    { headers: getHeaders() },
  );
  return Array.isArray(response.data?.items) ? response.data.items : [];
};

export const appendNeedToCallItemForOwner = async (ownerUserId, { targetUserId, name, phone, reason } = {}) => {
  const nextName = String(name || '').trim();
  const nextPhone = String(phone || '').trim();
  if (!ownerUserId) {
    throw new Error('Recipient is required');
  }
  if (!nextName) {
    throw new Error('Whom is required');
  }
  if (!nextPhone) {
    throw new Error('Phone number is required');
  }
  const response = await axios.post(
    `${API_URL}/need-to-call/item-for/${encodeURIComponent(ownerUserId)}`,
    {
      targetUserId: targetUserId || null,
      name: nextName,
      phone: nextPhone,
      reason: String(reason || '').trim(),
      done: false,
    },
    { headers: getHeaders() },
  );
  return response.data;
};
